import Vue from 'vue'
import Vuex from 'vuex'
import companies from './companies'
import domains from './domains'
import visitors from './visitors'
import products from './products'
import campaigns from './campaigns'
import variants from './variants'
import contacts from './contacts'
import forms from './forms'
import nstemplates from './newsletter-templates'
import auth from './auth'
import ui from './ui'
import imports from './imports'
import helpdesk from './helpdesk'


Vue.use(Vuex)



export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    ui,
    companies,
    domains,
    visitors,
    products,
    campaigns,
    contacts,
    forms,
    imports,
    nstemplates,
    helpdesk,
    variants
  }
})
